(function () {
  if (window.woProductThumbScrollBound) return;
  window.woProductThumbScrollBound = true;
  const desktop = window.matchMedia('(min-width: 761px)');
  const bindings = new Map();
  let mountFrame = 0;

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== String(value)) element.setAttribute(name, String(value));
  }

  function setClass(element, name, enabled) {
    if (element.classList.contains(name) !== enabled) element.classList.toggle(name, enabled);
  }

  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }

  function imageKey(value) {
    if (!value) return '';
    try { return new URL(value.trim(), document.baseURI).pathname; } catch (_) { return value.trim(); }
  }

  function format(value, index, total, description) {
    const values = { index: String(index + 1), total: String(total), description: description || '' };
    return value.replace(/\{(index|total|description)\}/g, function (_, key) { return values[key]; });
  }

  function bind(root, gallery, pager, template) {
    const controls = template.content.querySelector('.wo-thumb-controls').cloneNode(true);
    const previous = controls.querySelector('.wo-thumb-previous');
    const next = controls.querySelector('.wo-thumb-next');
    const abort = new AbortController();
    const originalPagerId = pager.getAttribute('id');
    const pagerId = template.dataset.pagerId;
    const nativeMore = new Map();
    let pilotNames = {};
    if (root.dataset.productId === '11272538587400' && template.dataset.productId === root.dataset.productId) {
      try { pilotNames = JSON.parse(template.dataset.pilotNames || '{}'); } catch (_) { pilotNames = {}; }
    }
    let frame = 0;
    let forceSelected = true;
    let lastSelected = null;
    let lastCount = -1;
    setAttribute(pager, 'id', pagerId);
    setAttribute(previous, 'aria-controls', pagerId);
    setAttribute(next, 'aria-controls', pagerId);
    pager.parentElement.appendChild(controls);

    function bullets() {
      return Array.from(pager.querySelectorAll('.swiper-pagination-bullet'));
    }

    function railEnabled() {
      return desktop.matches && gallery.classList.contains('aside-pager');
    }

    function position(bullet) {
      const rect = bullet.getBoundingClientRect();
      return { top: rect.top - pager.getBoundingClientRect().top + pager.scrollTop, height: rect.height };
    }

    function scrollLimit() {
      const items = bullets();
      if (!items.length || !pager.clientHeight) return 0;
      const last = position(items[items.length - 1]);
      return Math.max(0, last.top + last.height - pager.clientHeight);
    }

    function updateControls() {
      const max = scrollLimit();
      if (railEnabled() && pager.scrollTop > max) pager.scrollTop = max;
      setAttribute(previous, 'aria-disabled', pager.scrollTop <= 1);
      setAttribute(next, 'aria-disabled', max - pager.scrollTop <= 1);
    }

    function reveal(bullet) {
      if (!railEnabled() || !bullet || !pager.clientHeight) return;
      const box = position(bullet);
      if (box.top < pager.scrollTop) pager.scrollTop = box.top;
      else if (box.top + box.height > pager.scrollTop + pager.clientHeight) {
        pager.scrollTop = box.top + box.height - pager.clientHeight;
      }
      updateControls();
    }

    function normalizeMore(bullet) {
      if (!bullet.classList.contains('has-more') && !nativeMore.has(bullet)) return;
      if (!nativeMore.has(bullet)) nativeMore.set(bullet, { href: bullet.getAttribute('href'), overlays: new Map() });
      const original = nativeMore.get(bullet);
      setClass(bullet, 'has-more', false);
      if (bullet.hasAttribute('href')) bullet.removeAttribute('href');
      bullet.querySelectorAll(':scope > span > span').forEach(function (overlay) {
        if (!/^\+\s*\d+$/.test(overlay.textContent.trim())) return;
        if (!original.overlays.has(overlay)) original.overlays.set(overlay, overlay.getAttribute('data-wo-thumb-more'));
        setAttribute(overlay, 'data-wo-thumb-more', '');
      });
    }

    function nameThumbnails(items) {
      const media = Array.from(gallery.querySelectorAll('.swiper-outer .swiper-slide a[data-gallery-thumb]')).map(function (anchor) {
        return { anchor: anchor, image: anchor.querySelector('picture > img'), key: imageKey(anchor.dataset.galleryThumb) };
      });
      items.forEach(function (bullet, index) {
        normalizeMore(bullet);
        const image = bullet.querySelector('img');
        const key = imageKey(image && image.getAttribute('src'));
        const source = (media[index] && media[index].key === key ? media[index] : media.find(function (item) { return key && item.key === key; })) || (media.length === items.length ? media[index] : null);
        const fallback = format(template.dataset.fallbackFormat, index, items.length);
        const description = (source && (pilotNames[source.anchor.dataset.mediaId] || (source.image && source.image.alt.trim()))) || fallback;
        const label = description === fallback ? fallback : format(template.dataset.labelFormat, index, items.length, description);
        setAttribute(bullet, 'role', 'button');
        setAttribute(bullet, 'aria-label', label);
        if (image) setAttribute(image, 'alt', description);
      });
    }

    function update() {
      frame = 0;
      const items = bullets();
      const enabled = railEnabled();
      const countChanged = items.length !== lastCount;
      nameThumbnails(items);
      setProperty(gallery, '--wo-thumb-count', String(items.length));
      setProperty(gallery, '--wo-thumb-visible-count', String(Math.max(1, Math.min(items.length, 4))));
      setClass(gallery, 'wo-thumb-scroll-ready', enabled);
      const overflow = enabled && items.length > 4 && scrollLimit() > 1;
      setProperty(gallery, '--wo-thumb-controls-height', overflow ? '32px' : '0px');
      setClass(gallery, 'wo-thumb-has-overflow', overflow);
      if (controls.hidden === overflow) controls.hidden = !overflow;
      const selected = pager.querySelector('.swiper-pagination-bullet-active');
      if (enabled && (forceSelected || countChanged || selected !== lastSelected)) reveal(selected);
      if (!enabled && pager.scrollTop !== 0) pager.scrollTop = 0;
      lastSelected = selected;
      lastCount = items.length;
      forceSelected = false;
      updateControls();
    }

    function schedule(force) {
      forceSelected = forceSelected || force === true;
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function move(direction, button) {
      if (!railEnabled() || button.getAttribute('aria-disabled') === 'true') return;
      const first = bullets()[0];
      if (!first) return;
      const step = first.getBoundingClientRect().height + (parseFloat(window.getComputedStyle(pager).rowGap) || 0);
      pager.scrollTo({ top: Math.max(0, Math.min(scrollLimit(), pager.scrollTop + direction * step)), behavior: 'auto' });
      updateControls();
    }

    previous.addEventListener('click', function () { move(-1, previous); }, { signal: abort.signal });
    next.addEventListener('click', function () { move(1, next); }, { signal: abort.signal });
    pager.addEventListener('scroll', updateControls, { passive: true, signal: abort.signal });
    pager.addEventListener('focusin', function (event) { reveal(event.target.closest('.swiper-pagination-bullet')); }, { signal: abort.signal });
    pager.addEventListener('keydown', function (event) {
      if (event.key === ' ' && event.target.closest('.swiper-pagination-bullet')) event.preventDefault();
    }, { capture: true, signal: abort.signal });
    const changes = new MutationObserver(function () { schedule(false); });
    changes.observe(gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-current', 'role', 'aria-label', 'alt', 'src', 'data-gallery-thumb', 'data-media-id'] });
    const size = new ResizeObserver(function () { schedule(true); });
    size.observe(pager);
    const main = gallery.querySelector('.swiper-outer');
    if (main) size.observe(main);
    update();
    return {
      pager: pager,
      template: template,
      controls: controls,
      refresh: function () { schedule(true); },
      destroy: function () {
        abort.abort();
        changes.disconnect();
        size.disconnect();
        if (frame) window.cancelAnimationFrame(frame);
        nativeMore.forEach(function (original, bullet) {
          setClass(bullet, 'has-more', true);
          if (original.href === null) bullet.removeAttribute('href');
          else setAttribute(bullet, 'href', original.href);
          original.overlays.forEach(function (value, overlay) {
            if (value === null) overlay.removeAttribute('data-wo-thumb-more');
            else setAttribute(overlay, 'data-wo-thumb-more', value);
          });
        });
        nativeMore.clear();
        gallery.classList.remove('wo-thumb-scroll-ready', 'wo-thumb-has-overflow');
        ['--wo-thumb-count', '--wo-thumb-visible-count', '--wo-thumb-controls-height'].forEach(function (name) { gallery.style.removeProperty(name); });
        if (pager.id === pagerId) {
          if (originalPagerId === null) pager.removeAttribute('id');
          else pager.id = originalPagerId;
        }
        controls.remove();
      }
    };
  }

  function mount() {
    mountFrame = 0;
    const current = new Set();
    document.querySelectorAll('.wo-product-enhanced[data-template]').forEach(function (root) {
      const template = document.getElementById('wo-product-thumb-controls-template-' + root.dataset.template);
      if (!template) return;
      const gallery = root.querySelector('.l4pr');
      const pager = gallery && gallery.querySelector('.swiper-custom-pagination > .swiper-pagination-bullets');
      if (!pager) return;
      current.add(gallery);
      const old = bindings.get(gallery);
      if (old && old.pager === pager && old.template === template && old.controls.isConnected) return;
      if (old) old.destroy();
      bindings.set(gallery, bind(root, gallery, pager, template));
    });
    bindings.forEach(function (binding, gallery) {
      if (!current.has(gallery)) { binding.destroy(); bindings.delete(gallery); }
    });
  }

  desktop.addEventListener('change', function () { bindings.forEach(function (binding) { binding.refresh(); }); });
  new MutationObserver(function () {
    if (!mountFrame) mountFrame = window.requestAnimationFrame(mount);
  }).observe(document.body, { childList: true, subtree: true });
  mount();
})();
